import React from 'react';
import PropTypes from 'prop-types';

import themes from '../utils/iconColorThemes';

const TrashIcon = ({ className, theme }) => (
  <svg
    className={className}
    width="20px"
    height="18px"
    viewBox="0 0 14 18"
    version="1.1"
  >
    <g stroke={themes[theme]} strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M11.8055555,3.944384 C11.7786361,8.36643817 11.8055555,13.1170029 11.8055555,13.1170029 C11.8055555,14.1569535 11.0914851,15 10.2050592,15 L3.01716301,15 C2.13323328,15 1.41666667,14.1544215 1.41666667,13.1170029 L1.41666667,3.944384"
        id="Path"
      />
      <line
        x1="0"
        y1="2.34375"
        x2="13.2222222"
        y2="2.34375"
        id="Path"
        strokeLinecap="round"
      />
      <path
        d="M4.5333218,2.65625 L4.5333218,1.28144166 C4.5333218,0.573720975 5.10841422,0 5.81437723,0 L7.26615527,0 C7.97366261,0 8.54721069,0.576366692 8.54721069,1.28144166 L8.54721069,2.65625 M3.77777777,5.66509153 L3.77777777,13.3027249 M6.61111111,5.66509153 L6.61111111,13.3027249 M9.44444444,5.66509153 L9.44444444,13.3027249"
        id="Shape"
      />
    </g>
  </svg>
);

TrashIcon.propTypes = {
  theme: PropTypes.oneOf(Object.keys(themes)),
  className: PropTypes.string
};

TrashIcon.defaultProps = {
  className: '',
  theme: 'medium'
};

export default TrashIcon;
